import { UploadService } from "./../../services/tickets/Upload.service";
import { Component, OnInit, AfterViewChecked, ViewChild } from "@angular/core";
import { Location, DecimalPipe, DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { UploadTicket } from "../../model/domain/UploadTicket";
import { SnackbarService } from "../../services/snackbar.service";
import { LoaderService } from "../../services/loader.service";
import { DialogService } from "../../services/dialog.service";
import { DownloadService } from "../../services/download.service";
import { DateTime } from "luxon";
import { GroupsEnum } from "../../enum/groups.enum";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-upload-ticket",
  templateUrl: "./upload-ticket.component.html",
  styleUrls: ["./upload-ticket.component.css"],
})
export class UploadTicketComponent implements OnInit, AfterViewChecked {
  public groups = GroupsEnum;

  constructor(
    private snackBarService: SnackbarService,
    private dialogService: DialogService,
    private loaderService: LoaderService,
    private downloadService: DownloadService,
    private uploadService: UploadService,
    private authService: AuthService
  ) {}

  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  isEditing = false;
  canValidate = false;
  isReady = false;
  ngForm: NgForm;
  AccountManagers = [];
  fileList: File[] = [];
  file: File;

  model: UploadTicket;

  afuConfig = null;

  validators = {};

  // Init
  ngOnInit() {
    this.validatorsInit();
    this.modelInit();
  }

  ngAfterViewChecked() {
    if (!this.isReady) {
      setTimeout(() => {
        if (!this.canEdit()) {
          Object.values(this.frm.controls).forEach((c) => {
            c.disable();
          });
        }
      }, 0);
      this.isReady = true;
    }
  }

  validatorsInit() {
    // Add validators
  }

  modelInit() {
    this.model = new UploadTicket();
    this.model.ticketTypesId = null;
  }

  canEdit() {
    return true;
  }

  canShowGroup(groups: GroupsEnum[]): boolean {
    return this.authService.hasGroup(groups);
  }

  validateForm(f: NgForm): boolean {
    return true;
  }

  submit() {
    this.loaderService.addLoader();

    const editing = this.isEditing;

    this.register(this.frm)
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
          return throwError(err);
        })
      )
      .subscribe(
        (r) => {
          this.loaderService.removeLoader();
        },
        () => {}
      );
  }

  register(f: NgForm) {
    const editing = this.isEditing;

    if (!this.canEdit()) {
      return;
    }

    try {
      const isValid = this.validateForm(f);
      if (isValid) {
        let data = Object.assign({}, this.model);

        return this.sendSubmit(data, editing);
      }
    } catch (error) {
      return throwError(error);
    }
  }

  openFile(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      this.file = this.fileList[0];
    }
  }

  sendSubmit(data: UploadTicket, editing: boolean = false) {
    data.fileBase64 = this.file;
    data.ticketTypesId = this.model.ticketTypesId;
    const method = this.uploadService.uploadTicket(data);

    return method
      .pipe(
        catchError((err) => {
          return throwError("Erro ao fazer upload da(s) boleta(s).");
        })
      )
      .pipe(
        catchError((err) => {
          this.snackBarService.open(
            "Erro ao fazer upload da(s) boleta(s).",
            "OK",
            {
              verticalPosition: "top",
              horizontalPosition: "right",
            }
          );
          return throwError("Erro ao fazer upload da(s) boleta(s).");
        })
      )
      .pipe(
        map((result) => {
          if (result != null) {
            this.snackBarService.open(
              "Erro ao fazer upload da(s) boleta(s).",
              "OK",
              {
                verticalPosition: "top",
                horizontalPosition: "right",
              }
            );
            return this.dialogService.modalerror(
              result,
              this.model.ticketTypesId
            );
          } else {
            window.location.reload();
            this.snackBarService.open("Boleta(s) Cadastrada(s).", "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            return this.model;
          }
        })
      );
  }

  ticketTemplate(ticketTypesId) {
    this.loaderService.addLoader();
    ticketTypesId = this.model.ticketTypesId;
    const method = this.uploadService.ticketTemplate(ticketTypesId);

    return method.subscribe(
      (data: Blob) => {
        const filename = `boletas_${DateTime.local().toFormat(
          "yyyyMMdd"
        )}.xlsx`;
        this.downloadService.downloadFile(data, filename);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível baixar o template da boleta.",
          "OK"
        );
      }
    );
  }
}
